<template>
  <div v-if="can('update', 'payroll_info')">
    <b v-if="employeeState=='showing'"><p class="text-danger" v-if="edited">Los cambios no han sido guardados. <a href="#" @click.prevent="saveChanges">Guardar.</a></p></b>
    <b-button class="float-right" @click="resetNewDefaultPenalties" v-if="edited == true" >Descartar cambios</b-button>
    <b-table responsive v-if="defaultPenalties.length>0" :fields="defaultPenaltyFields" :items="defaultPenalties" :stacked="'md'" hover striped></b-table>
    <!-- b-button variant="success" v-if="state=='show'" @click="create">Agregar descuento fijo periódico</b-button -->
    <div v-if="state=='creating'">
      <b-form-group horizontal label="Concepto">
        <b-form-select :options="['INFONAVIT', 'Transporte', 'SGM']" @input="updateDefaultPenalty(['reason', $event])">
        </b-form-select>
      </b-form-group>
      <b-form-group horizontal label="A descontar por semana">
        <b-form-input type="number" @input="updateDefaultPenalty(['amount', $event])" :value="amount"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Comenzar a cobrar desde">
        <b-form-input type="date" @input="updateDefaultPenalty(['from_date', $event])" :value="from_date"></b-form-input>
      </b-form-group>
      <b-form-group horizontal label="Terminar de cobrar el" v-b-tooltip.hover title="Puede estar vacío">
        <b-form-input type="date" @input="updateDefaultPenalty(['to_date', $event])" :value="to_date"></b-form-input>
      </b-form-group>

      <b-button variant="success" @click="addIfValid">Agregar</b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { Validation } from '../../utils';
export default{
  props: {
    payrollConfig: {
      required: true,
      type: Object
    }
  },
  data (){
    return {
      defaultPenaltyFields: [
        {
          key: 'reason',
          label: 'Concepto',
        },
        {
          key: 'amount',
          label: 'A descontar por semana',
          sortable: true
        },
        {
          key: 'from_date',
          label: 'Cobrar desde el',
          sortable: true
        },
        {
          key: 'to_date',
          label: 'Terminar de cobrar el',
          sortable: true
        },
      ]
    }
  },
  methods: {
    can: (action, resource)=>{
      if(permissions===null) return false
      if(typeof(permissions[resource])==='undefined') return false
      return permissions[resource].includes(action)
    },
    ...mapActions(['resetNewDefaultPenalties', 'saveChanges']),
    ...mapMutations({
      updateDefaultPenalty: 'updateNewDefaultPenaltyAttribute',
      create: 'creatingDefaultPenalty'
    }),
    addIfValid (){
      var validation = this.valid()
      if(validation.valid)
        this.$store.dispatch('addDefaultPenalty');
      else
        this.$store.dispatch('displayError',validation.messageBag);
    },
    valid (){
      var validator = new Validation();
      validator.rule(
        this.reason!='', 'El concepto no puede estar vacío')
      validator.rule(
        this.from_date!='', 'Debe haber una fecha para comenzar a descontar')
      validator.rule(
        this.amount>0, 'El valor a descontar debe ser mayor a cero')
      
      return validator.validate()
    }
  },
  computed: {
    ...mapGetters({
      edited: 'defaultPenaltyEdited'
    }),
    ...mapState({
      employeeState: state=>state.employeeManager.state,
      state: state=>state.employeeManager.defaultPenaltyState,
      amount: state=>state.employeeManager.newDefaultPenalty.amount,
      reason: state=>state.employeeManager.newDefaultPenalty.reason,
      from_date: state=>state.employeeManager.newDefaultPenalty.from_date,
      to_date: state=>state.employeeManager.newDefaultPenalty.to_date,
      }),
    defaultPenalties() {
      return this.payrollConfig.defaultPenalties ? this.payrollConfig.defaultPenalties : [];
    }
  }
  
}
</script>
